import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { FactoryNodeScreenDisplayComponent } from './factory-node-screen-display.component';
import { FactoryNodeDisplayDirective } from './factory-node-screen-display.directive';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule
    ],
    exports: [FactoryNodeScreenDisplayComponent],
    declarations: [
        FactoryNodeScreenDisplayComponent,
        FactoryNodeDisplayDirective
    ],
    providers: [],
})
export class FactoryNodeScreenDisplayModule { }
